<template>
    <div
        class="uik-tag-container__wrapper"
        :class="{'uik-tag-container__collapsed': collapsed}">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "UikTagContainer",
    props: {
        collapsed: { type: Boolean, default: false } // Style properties for collapsed state are defined in Tag component
    }
}
</script>

<style lang="scss">
.uik-tag-container__wrapper {
  margin: -3px;
  &>* {
    margin: 3px;
  }
}
</style>
